import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconDatasets: FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" {...rest}>
    <path
      d="M17.5 4.1665C17.5 5.54722 14.1421 6.6665 10 6.6665C5.85786 6.6665 2.5 5.54722 2.5 4.1665M17.5 4.1665C17.5 2.78579 14.1421 1.6665 10 1.6665C5.85786 1.6665 2.5 2.78579 2.5 4.1665M17.5 4.1665V15.8332C17.5 17.2165 14.1667 18.3332 10 18.3332C5.83333 18.3332 2.5 17.2165 2.5 15.8332V4.1665M17.5 8.10002C17.5 9.48335 14.1667 10.6 10 10.6C5.83333 10.6 2.5 9.48335 2.5 8.10002M17.5 12.0332C17.5 13.4165 14.1667 14.5332 10 14.5332C5.83333 14.5332 2.5 13.4165 2.5 12.0332"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconDatasets.defaultProps = defaultIconProps;
